export default __webpack_public_path__ + "static/media/ito.42990053.svg";